import axios from 'axios'
import { ORDER_LIST_MY_RESET } from '../constants/orderConstants'
import { 
    USER_LOGIN_FAIL, 
    USER_LOGIN_REQUEST, 
    USER_LOGIN_SUCCESS, 
    USER_LOGOUT, 
    USER_REGISTER_REQUEST, 
    USER_REGISTER_SUCCESS,
    USER_REGISTER_FAIL, 
    USER_DETAILS_REQUEST,
    USER_DETAILS_FAIL,
    USER_DETAILS_SUCCESS,
    USER_UPDATE_PROFLE_REQUEST,
    USER_UPDATE_PROFLE_SUCCESS,
    USER_UPDATE_PROFLE_FAIL,
    USER_DETAILS_RESET,
    USER_LIST_REQUEST,
    USER_LIST_SUCCESS,
    USER_LIST_FAIL,
    USER_LIST_RESET,
    USER_DELETE_REQUEST,
    USER_DELETE_SUCCESS,
    USER_DELETE_FAIL,
    USER_UPDATE_REQUEST,
    USER_UPDATE_SUCCESS,
    USER_UPDATE_FAIL
} from "../constants/userConstants"

export const login =(email,password)=>async (dispatch)=>{
    try{
        dispatch({
            type:USER_LOGIN_REQUEST
        })
        const config={
            headers:{
                'Content-Type':'application/json'
            }
        }
        const {data}=await axios.post('https://shop-strike.herokuapp.com/api/users/login',{email,password},config)
        dispatch({
            type:USER_LOGIN_SUCCESS,
            payload:data
        })
        localStorage.setItem('userInfo',JSON.stringify(data))
    }catch(e){
        dispatch({
            type:USER_LOGIN_FAIL,
            payload:e.response && e.response.data.message ? e.response.data.message : e.message
        })
    }
}

export const logout=()=>(dispatch)=>{
    localStorage.removeItem('userInfo')
    dispatch({type:USER_LOGOUT})
    dispatch({type:USER_DETAILS_RESET})
    dispatch({type:ORDER_LIST_MY_RESET})
    dispatch({type:USER_LIST_RESET})
}

export const register = (name, email, password) => async (dispatch) => {
    try {
        dispatch({
            type: USER_REGISTER_REQUEST,
        })
        const config = {
            headers: {
            'Content-Type': 'application/json',
            },
        }
        const { data } = await axios.post(
            'https://shop-strike.herokuapp.com/api/users',
            { name, email, password },
            config
        )
        dispatch({
            type: USER_REGISTER_SUCCESS,
            payload: data,
        })
        dispatch({
            type: USER_LOGIN_SUCCESS,
            payload: data,
        })
        localStorage.setItem('userInfo', JSON.stringify(data))
    }catch (error) {
        dispatch({
            type: USER_REGISTER_FAIL,
            payload:
                error.response && error.response.data.message
                ? error.response.data.message
                : error.message,
        })
    }
}

export const getUserDetails = (id) => async (dispatch,getState) => {
    try {
        const {userLogin:{userInfo}}=getState()
        dispatch({
            type: USER_DETAILS_REQUEST,
        })
        const config = {
            headers: {
            'Content-Type': 'application/json',
            Authorization:`Bearer ${userInfo.token}` 
            },
        }
        const { data } = await axios.get(`https://shop-strike.herokuapp.com/api/users/${id}`,config)
        dispatch({
            type: USER_DETAILS_SUCCESS,
            payload: data,
        })
    }catch (error) {
        dispatch({
            type: USER_DETAILS_FAIL,
            payload:
                error.response && error.response.data.message
                ? error.response.data.message
                : error.message,
        })
    }
}

export const updateUserProfile = (user) => async (dispatch,getState) => {
    try {
        const {userLogin:{userInfo}}=getState()
        dispatch({
            type: USER_UPDATE_PROFLE_REQUEST,
        })
        const config = {
            headers: {
            'Content-Type': 'application/json',
            Authorization:`Bearer ${userInfo.token}` 
            },
        }
        const { data } = await axios.put(`https://shop-strike.herokuapp.com/api/users/profile`,user,config)
        dispatch({
            type: USER_UPDATE_PROFLE_SUCCESS,
            payload: data,
        })
        localStorage.removeItem('userInfo')
        localStorage.setItem('userInfo', JSON.stringify(data))
    }catch (error) {
        dispatch({
            type: USER_UPDATE_PROFLE_FAIL,
            payload:
                error.response && error.response.data.message
                ? error.response.data.message
                : error.message,
        })
    }
}

export const listUsers = (user) => async (dispatch,getState) => {
    try {
        const {userLogin:{userInfo}}=getState()
        dispatch({
            type: USER_LIST_REQUEST,
        })
        const config = {
            headers: {
            Authorization:`Bearer ${userInfo.token}` 
            },
        }
        const { data } = await axios.get(`https://shop-strike.herokuapp.com/api/users`,config)    
        dispatch({
            type: USER_LIST_SUCCESS,
            payload: data,
        })
    }catch (error) {
        dispatch({
            type: USER_LIST_FAIL,
            payload:
                error.response && error.response.data.message
                ? error.response.data.message
                : error.message,
        })
    }
}

export const deleteUser = (id) => async (dispatch,getState) => {
    try {
        const {userLogin:{userInfo}}=getState()
        dispatch({
            type: USER_DELETE_REQUEST,
        })
        const config = {
            headers: {
            Authorization:`Bearer ${userInfo.token}` 
            },
        }
        const { data } = await axios.delete(`https://shop-strike.herokuapp.com/api/users/${id}`,config)    
        dispatch({
            type: USER_DELETE_SUCCESS,
            payload: data, 
        })
    }catch (error) {
        dispatch({
            type: USER_DELETE_FAIL,
            payload:
                error.response && error.response.data.message
                ? error.response.data.message
                : error.message,
        })
    }
}

export const updateUser = (user) => async (dispatch,getState) => {
    try {
        const {userLogin:{userInfo}}=getState()
        dispatch({
            type: USER_UPDATE_REQUEST,
        })
        const config = {
            headers: {    
                'Content-Type': 'application/json',
                Authorization:`Bearer ${userInfo.token}` 
            },
        }
        const { data } = await axios.put(`https://shop-strike.herokuapp.com/api/users/${user._id}`,user,config)    
        dispatch({
            type: USER_UPDATE_SUCCESS,
            payload: data, 
        })
        dispatch({
            type: USER_DETAILS_SUCCESS,
            payload: data, 
        })
    }catch (error) {
        dispatch({
            type: USER_UPDATE_FAIL,
            payload:
                error.response && error.response.data.message
                ? error.response.data.message
                : error.message,
        })
    }
}